import api from 'api';
import templates from 'modules/templates';
import photoRepo from 'repositories/ladies';
import bodyTypeConvertor from 'modules/body-type/convertor';
import config from 'config';

export function create(container, ladyId) {
    let profilePromise = new Promise(resolve => {
        api.ladies.get(ladyId, function(err, data){
            resolve(data);
        });
    });
    let tmplPromise = new Promise(resolve => {
        templates.get('profile-interview', function (err, tpl) {
            resolve(tpl);
        })
    });

    let textPromise = new Promise(resolve => {
        api.texts.get('lady/card', function(err, data){
            resolve(data);
        });
    });

    Promise.all([profilePromise,tmplPromise, textPromise]).then(values => {
        var profileModel = values[0];
        if(profileModel.interview && profileModel.interview.length > 0){
            var tpl = values[1];
            var localization  = values[2];
            profileModel.interviewListShort = profileModel.interview.slice(0,2);
            var ladyNameLocalized = `${profileModel.name}'s`;
            profileModel.headerText = (localization['interview-format'] || '').replace('{0}', ladyNameLocalized);
            container.append(tpl.render(profileModel));
        }

    });
}